import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createTask} from "../../../actions/tasks";
import {TaskForm} from "./TaskForm";
import {currentEffectiveUserId} from "../../../reducers/ui";

const TaskNew = props => {
  const { projectid, onSubmit, onCancel, userid } = props;
  return <Card title='Task Details' className={'edit-view'}>
    <TaskForm projectid={projectid} onCancel={onCancel} onSubmit={onSubmit} userid={userid}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => ({ projectid: props.match.params.id, userid: currentEffectiveUserId(state) }),
    (dispatch, props) => ({
      onSubmit: (task) => {
        return dispatch(createTask(props.match.params.id, task, (taskid) => props.history.push(`/projects/${props.match.params.id}/tasks/${taskid}`)));
      },
      onCancel: () => props.history.goBack()
    })
  )
)(TaskNew);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskNew.js